import React, { useState } from "react";
import {
  Button,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { formatDate } from "../../utils";
import { useANCDates } from "../../hooks/useANCDates";
import { useANCData } from "../../hooks/useANCData";
import ANCShow from "./ANCShow";
import ANCIntake from "./ANCIntake";

const ANC = ({ patient_id }) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [isIntake, setIsIntake] = useState(false);

  const {
    data: ANCDates,
    isLoading: isANCDatesLoading,
    isError: isANCDatesError,
  } = useANCDates(patient_id);

  const {
    data: ANCData,
    isLoading: isANCDataLoading,
    isError: isANCDataError,
  } = useANCData(patient_id, selectedDate);

  if (isANCDatesLoading) {
    return <h3>Loading ANC Dates...</h3>;
  }
  if (isANCDatesError) {
    return <h3>Error loading ANC dates.</h3>;
  }

  const handleBackClick = () => {
    setIsIntake(false);
    setSelectedDate(null);
  };

  const selectPanel = (
    <div className="card">
      <h2>Select a Date to View ANC</h2>
      <Box display="flex" alignItems="center" mb={2} gap={2}>
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel id="rf-date-select-label">Date</InputLabel>
          <Select
            size="small"
            labelId="rf-date-select-label"
            value={selectedDate}
            label="Date"
            onChange={(e) => setSelectedDate(e.target.value)}
          >
            {ANCDates.map((date) => (
              <MenuItem key={date} value={date}>
                {formatDate(date)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Box sx={{ ml: "auto" }}>
          <Button
            variant="outlined"
            onClick={() => setIsIntake(true)}
            sx={{
              textTransform: "none",
              fontWeight: "bold",
            }}
          >
            ANC Intake
          </Button>
        </Box>
      </Box>

      {selectedDate && (
        <div style={{ marginTop: 24 }}>
          {isANCDataLoading ? (
            <h3>Loading ANC Data...</h3>
          ) : isANCDataError ? (
            <h3>Error loading ANC data.</h3>
          ) : (
            <ANCShow ANCData={ANCData} />
          )}
        </div>
      )}
    </div>
  );

  const intakePanel = (
    <div className="card">
      <Box display="flex" justifyContent="flex-start" mb={2}>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIosIcon fontSize="small" />}
          onClick={handleBackClick}
          sx={{
            backgroundColor: "#f5f5f5",
            color: "#333",
            borderColor: "#ccc",
            marginBottom: "8px",
            textTransform: "none",
            fontWeight: 500,
            "&:hover": {
              backgroundColor: "#e0e0e0",
              borderColor: "#bbb",
            },
          }}
        >
          Back to Dates
        </Button>
      </Box>
      <ANCIntake
        patient_id={patient_id}
        setSelectedDate={setSelectedDate}
        setIsIntake={setIsIntake}
      />
    </div>
  );

  return (
    <>
      {/* Add ToastContainer here at the top level */}
      <ToastContainer
        position="top-right"
        autoClose={6000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      {isIntake ? intakePanel : selectPanel}
    </>
  );
};

export default ANC;
